var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 17.4477C14.1133 17.4477 17.4477 14.1133 17.4477 10.0001C17.4477 5.8869 14.1133 2.55251 10.0001 2.55251C5.8869 2.55251 2.55251 5.8869 2.55251 10.0001C2.55251 14.1133 5.8869 17.4477 10.0001 17.4477ZM19.0002 10.0001C19.0002 14.9707 14.9707 19.0002 10.0001 19.0002C5.02947 19.0002 1 14.9707 1 10.0001C1 5.02947 5.02947 1 10.0001 1C14.9707 1 19.0002 5.02947 19.0002 10.0001Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5702 9.40931L5.79831 9.40931L8.75146 5.2749L8.75146 14.725L7.5702 14.725L7.5702 9.40931ZM12.2952 5.2749L12.2952 10.5906L14.0671 10.5906L11.114 14.725L11.114 5.2749L12.2952 5.2749Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swapIcon.35b6f93a787f605ecdab9a6a384e028c.svg";
export { ForwardRef as ReactComponent };